console.log('Vite ⚡️ Rails');
console.log(
  'Visit the guide for more information: ',
  'https://vite-ruby.netlify.app/guide/rails'
);

import '@hotwired/turbo-rails';
import '../controllers';

import '../styles/convert.scss';
